export default "__VITE_ASSET__4d9d952c__"